import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=43f9e7da&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=43f9e7da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f9e7da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43f9e7da')) {
      api.createRecord('43f9e7da', component.options)
    } else {
      api.reload('43f9e7da', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=43f9e7da&scoped=true&", function () {
      api.rerender('43f9e7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8KWZhCM6oj2KV/JS/comp/CookieBox.vue"
export default component.exports